import React, { useEffect } from 'react';
import {
  Container,
  Col,
  Row,
  Card,
  CardBody,
  Label,
  CustomInput,
  FormGroup,
  Button,
} from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import Select from 'react-select';
import useGet from '../../helpers/hooks/useGet';
import { useState } from 'react';
import useAttachement from '../../helpers/hooks/useAttachments';
import toastr from 'toastr';
import usePost from '../../helpers/hooks/usePost';
import { useHistory } from 'react-router-dom';
const AddAdvisoryStat = (props) => {
  const history = useHistory();

  const [postAdvisoryStat, postedData, postingError, dataPosting] = usePost(
    '/advisory-stats'
  );
  const { upload, error, loading: imagesUploading, urls } = useAttachement();

  const [selectedImage, setSelectedImage] = useState();
  const handleFormSubmit = (event, errors, values) => {
    if (dataPosting) {
      return;
    }
    if (errors.length > 0) {
      return toastr.warning('Please fix errors in the form');
    }

    if (!selectedImage) {
      return toastr.warning('Please select image');
    }
    upload([selectedImage]).then((_urls) => {
      const obj = {
        ...values,
        image: _urls[0],
      };
      postAdvisoryStat(obj);
    });
  };
  useEffect(() => {
    if (postingError) {
      console.log(postingError);
      toastr.error(postingError.error.message);
    }
  }, [postingError]);
  useEffect(() => {
    if (postedData) {
      toastr.success('Advisory Stat has been added successfully');
      history.push('/system/advisory-stats');
    }
  }, [history, postedData]);
  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <AvForm className='needs-validation' onSubmit={handleFormSubmit}>
            <Row>
              <Col md={{ size: 8, offset: 2 }}>
                <h4>Add New Problem Category</h4>
                <Card>
                  <CardBody>
                    <FormGroup>
                      <Label htmlFor='name'>Name</Label>
                      <AvField
                        name='name'
                        placeholder='Name'
                        type='text'
                        errorMessage='Enter Name'
                        className='form-control'
                        validate={{ required: { value: true } }}
                        id='name'
                      />
                    </FormGroup>
                    <FormGroup>
                      <div className='custom-file'>
                        <CustomInput
                          type='file'
                          className='custom-file-input'
                          id='image'
                          accept='image/*'
                          onChange={(e) => {
                            setSelectedImage(e.target.files[0]);
                          }}
                        />
                        <Label className='custom-file-label' htmlFor='image'>
                          {selectedImage ? selectedImage.name : 'Choose Image'}
                        </Label>
                      </div>
                    </FormGroup>
                  </CardBody>
                </Card>
                <div className='text-right mb-5'>
                  <Button
                    color='primary'
                    disabled={dataPosting || imagesUploading}
                  >
                    {dataPosting || imagesUploading
                      ? 'Saving...'
                      : 'Save Category'}
                  </Button>
                </div>
              </Col>
            </Row>
          </AvForm>
        </Container>
      </div>
    </>
  );
};

export default AddAdvisoryStat;
